import { forwardRef } from "react";
import {
  Box,
  Flex,
  Heading,
  Slider,
  SliderFilledTrack,
  SliderMark,
  SliderThumb,
  SliderTrack,
  Text
} from "@chakra-ui/react";

function SliderWithTitle({ title, subTitle, value, setValue, isDisabled, marginBlock = 12 }, ref) {

  const labelStyles = {
    mt: "2",
    ml: "-2.5",
    fontSize: "sm"
  };

  return (
    <Box marginBlock={marginBlock}>
      <Flex direction="column" gap={2}>
        <Heading size="sm">{title}</Heading>
        <Text size="sm" color="esg_gray.300">{subTitle}</Text>
        <Slider aria-label="slider-ex-6"
                isDisabled={isDisabled}
                marginBlockStart={8} value={value}
                colorScheme="customScheme"
                focusThumbOnChange={false}
                onChange={(val) => setValue(val)} ref={ref}>
          <SliderMark value={25} {...labelStyles}>
            25%
          </SliderMark>
          <SliderMark value={50} {...labelStyles}>
            50%
          </SliderMark>
          <SliderMark value={75} {...labelStyles}>
            75%
          </SliderMark>
          <SliderMark
            value={value}
            textAlign="center"
            bg="customScheme.500"
            color="white"
            mt="-10"
            ml="-5"
            w="12"
          >
            {value}%
          </SliderMark>
          <SliderTrack>
            <SliderFilledTrack />
          </SliderTrack>
          <SliderThumb />
        </Slider>
      </Flex>
    </Box>
  );
}

export default forwardRef(SliderWithTitle);
